import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_SERVER}/campaign/`;
const API_ERP_URL = `${process.env.REACT_APP_API_SERVER}/Web/`;

/*
 * 고객정보 저장
 */

const CustomerInfoSave = async (
  orderNo,
  salesNo,
  orderKey,
  travelerNo,
  data,
  imageUrl,
  usePassport
) => {
  const json = JSON.stringify(data);

  //console.log(json);

  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo, 리스트값: null },
      { 컬럼명: "@판매번호", 값: salesNo, 리스트값: null },
      { 컬럼명: "@고유코드", 값: orderKey, 리스트값: null },
      { 컬럼명: "@여행객번호", 값: travelerNo, 리스트값: null },
      { 컬럼명: "@리스트", 값: json, 리스트값: null },
      { 컬럼명: "@여권사본경로", 값: imageUrl, 리스트값: null },
      { 컬럼명: "@여권사본필요여부", 값: usePassport, 리스트값: null },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_T_알림톡_고객정보저장",
  };

  //console.log("body", body);

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const SalesNoSave = async (orderNo, salesNo, orderKey) => {
  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo },
      { 컬럼명: "@판매번호", 값: salesNo },
      { 컬럼명: "@고유코드", 값: orderKey },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_S_고객정보알림톡_주문판매_발권요청",
  };

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data.table[0];
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const orderInfo = async (orderNo, salesNo, orderKey) => {
  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo },
      { 컬럼명: "@판매번호", 값: salesNo },
      { 컬럼명: "@고유코드", 값: orderKey },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_S_고객정보알림톡_주문판매정보",
  };

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data.table[0];
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const TravelerList = async (orderNo, salesNo, orderKey, status) => {
  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo },
      { 컬럼명: "@판매번호", 값: salesNo },
      { 컬럼명: "@고유코드", 값: orderKey },
      { 컬럼명: "@입력상태", 값: status },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_S_고객정보알림톡_주문판매여행객",
  };

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const TravelerListAll = async (orderNo, salesNo, orderKey, status) => {
  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo },
      { 컬럼명: "@판매번호", 값: salesNo },
      { 컬럼명: "@고유코드", 값: orderKey },
      { 컬럼명: "@입력상태", 값: status },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_S_고객정보알림톡_주문판매여행객전체",
  };

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const TravelerInfo = async (orderNo, salesNo, orderKey, customerNo) => {
  const body = {
    Table1: [
      { 컬럼명: "@주문번호", 값: orderNo },
      { 컬럼명: "@판매번호", 값: salesNo },
      { 컬럼명: "@고유코드", 값: orderKey },
      { 컬럼명: "@여행객번호", 값: customerNo },
    ],
  };

  const params = {
    procedureName: "DBO.RCT_S_고객정보알림톡_여행객",
  };

  try {
    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      params,
    });

    //console.log("response", response.data.table[0]);

    if (response.data.hasOwnProperty("table")) {
      return response.data.table[0];
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const customerInfo = async (kind, customerNo, customerCode) => {
  try {
    const response = await axios.get(API_URL + "GetInfo", {
      params: { kind, customerNo, customerCode },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const customerCancel = async (kind, customerNo, customerCode) => {
  try {
    const response = await axios.get(API_URL + "CampaignCancel", {
      params: { kind, customerNo, customerCode },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const customerCallRequest = async (
  kind,
  customerNo,
  customerCode,
  date,
  time,
  memo
) => {
  //console.log("customerCode", kind, customerNo, customerCode, date, time, memo);

  const body = {
    kind,
    customerNo,
    customerCode,
    date,
    time,
    memo: memo || "",
  };

  // console.log("body", body);

  try {
    const response = await axios.post(API_URL + "CallRequest", body);

    // console.log("Data", response.data);

    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateWebStatus = async (kind, customerNo, customerCode) => {
  try {
    const response = await axios.get(API_URL + "CampaignWebStatusUpdate", {
      params: { kind, customerNo, customerCode },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateProductCode = async (customerNo, productName) => {
  try {
    const body = {
      Table1: [
        { 컬럼명: "@캠페인고객번호", 값: customerNo, 리스트값: null },
        { 컬럼명: "@상품명", 값: productName, 리스트값: null },
      ],
    };

    const params = {
      procedureName: "DBO.RCT_T_캠페인고객클릭상품",
    };

    const response = await axios.post(API_ERP_URL + "GetDataSet", body, {
      // headers: authHeader(),
      params,
    });

    if (response.data.hasOwnProperty("table")) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

const CampaignService = {
  customerInfo,
  customerCancel,
  customerCallRequest,
  updateWebStatus,
  updateProductCode,
  orderInfo,
  TravelerList,
  TravelerInfo,
  CustomerInfoSave,
  TravelerListAll,
  SalesNoSave,
};

export default CampaignService;
